import React, { useState, useEffect, useCallback } from "react";
import "./LocationPhone.scss";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import { getPageContent } from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";

const LocationPhone = (props) => {
  const { hostLanguage } = useLangContext();
  const [contentDetails, setContentDetails] = useState();

  // get page content
  const getAllPageContent = useCallback(async () => {
    try {
      let apiRes = await getPageContent(hostLanguage, "locations_page_data_phone");
      let responseData = await apiRes.json();
      if (responseData.res) {
        setContentDetails(responseData.data);
      } else {
        console.error(responseData.msg);
      }
    } catch (error) {
      console.error(error);
    }
  }, [hostLanguage]);

  useEffect(() => {
    getAllPageContent();
  }, [getAllPageContent]);

  return (
    <div className="LocationPhoneGrid">
      <div className="description">
        <h3>{props.text}</h3>
        <Row>
          <Col>
            <p>
              {props.price} CHF {contentDetails?.locations_page_data_phone?.monthly_incl_tax}
            </p>
          </Col>
          <Col
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Link to={`/Pricing/Phone/`+props.country+`/`+props.id}>
              {contentDetails?.locations_page_data_phone?.button}
            </Link>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default LocationPhone;
